import { Instagram, Mail } from "lucide-react";

const INSTAGRAM_URL = "https://www.instagram.com/edith.wins";
const CONTACT_EMAIL = "thabetirishiteja21@gmail.com";

const footerColumns = [
  {
    heading: "Product",
    links: [
      { label: "Problem", href: "#problem" },
      { label: "Protocol", href: "#solution" },
      { label: "AI Preview", href: "#ai-preview" },
    ],
  },
  {
    heading: "Explore",
    links: [
      { label: "Community", href: "#social-proof" },
      { label: "Early Access", href: "#early-access" },
      { label: "FAQ", href: "#faq" },
    ],
  },
  {
    heading: "Contact",
    links: [
      { label: "Email Us", href: `mailto:${CONTACT_EMAIL}`, external: false },
      {
        label: "Instagram",
        href: INSTAGRAM_URL,
        external: true,
      },
    ],
  },
  {
    heading: "Join",
    links: [{ label: "Join the Waitlist", href: "#final-cta" }],
  },
];

export default function Footer() {
  return (
    <footer
      id="footer"
      className="nm-section-dark reveal-section"
      data-reveal
      data-testid="footer"
    >
      <div className="nm-container py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-8">
          {footerColumns.map((col) => (
            <div key={col.heading} className="text-center md:text-left">
              <p className="text-sm font-bold uppercase tracking-wide text-[#111] mb-4">
                {col.heading}
              </p>
              <ul className="space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      target={link.external ? "_blank" : undefined}
                      rel={link.external ? "noopener noreferrer" : undefined}
                      className="text-sm font-medium text-[#111] no-underline hover:underline underline-offset-4 transition-opacity"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 md:mt-14 rounded-xl border border-black/10 px-5 py-4 md:px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <span className="text-sm text-black/50 text-center sm:text-left">
            © {new Date().getFullYear()} EDITH. All Rights Reserved.
          </span>
          <div className="flex items-center gap-5">
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow EDITH on Instagram"
              className="text-[#111] hover:opacity-60 transition-opacity"
            >
              <Instagram size={20} strokeWidth={2} />
            </a>
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              aria-label="Email EDITH"
              className="text-[#111] hover:opacity-60 transition-opacity"
            >
              <Mail size={20} strokeWidth={2} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
